function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import Stars from './stars.js';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css';
import '../style/styles.css';

/**
 * Renders a single question, including the interactive stars
 *
 * @param {Props} props
 * @param {number} [props.averageRating]
 * @param {boolean} [props.inverted=false]
 * @param {string} props.question
 * @param {Function} props.ratingHandler
 * @param {number} [props.starAmount=5]
 * @param {SemanticUIColors} [props.starColor=yellow]
 * @param {boolean} [props.votingIsOver=false]
 */
export var Question =
/*#__PURE__*/
function (_Component) {
  _inherits(Question, _Component);

  function Question() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Question);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Question)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      currentlySelectedRating: -1
      /**
       * Handle clicks on a star
       */

    };

    _this.handleClick = function (selectedRating) {
      if (!_this.props.votingIsOver) {
        _this.setState({
          currentlySelectedRating: selectedRating
        });

        _this.props.ratingHandler(_this.props.question, selectedRating);
      }
    };

    return _this;
  }

  _createClass(Question, [{
    key: "render",
    value: function render() {
      return React.createElement("tr", null, React.createElement("td", null, this.props.question), React.createElement("td", {
        className: "single line right aligned"
      }, React.createElement(Stars, {
        averageRating: this.props.averageRating,
        clickHandler: this.handleClick,
        inverted: this.props.inverted,
        currentlySelectedRating: this.state.currentlySelectedRating,
        starAmount: this.props.starAmount,
        starColor: this.props.starColor,
        votingIsOver: this.props.votingIsOver
      })));
    }
  }]);

  return Question;
}(Component);
Question.defaultProps = {
  inverted: false,
  starAmount: 5,
  starColor: 'yellow',
  votingIsOver: false
};
export default Question;